import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import styled from 'styled-components';
import './App.css';
import Input from './examples/input';
import Output from './examples/output';
import 'react-tabs/style/react-tabs.css';

function App() {
  return (
    <Container>
      <Tabs className={'TabsRoot'}>
        <TabList className={'TabsList'}>
          <Tab className={'TabsTrigger'}>Input Example</Tab>
          <Tab className={'TabsTrigger'}>Output Example</Tab>
        </TabList>

        <TabPanel>
          <Input />
        </TabPanel>
        <TabPanel>
          <Output />
        </TabPanel>
      </Tabs>
    </Container>
  );
}

export default App;

const Container = styled.div`
  display: flex;
  gap: 30px;
  flex-direction: column;
  width: 400px;
`;
